import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { logout } from "../actions/auth"
import {
	BanksListResponse,
	BanksListState,
	BankState,
	fetchBanks,
	getBanksPaginated,
	updateBank,
} from "../actions/bank"

const initialState: BanksListState = {
	loading: false,
	loadingFetch: false,
	error: undefined,
	errorFetch: undefined,
	list: undefined,
}

const bankPaginatedSlice = createSlice({
	name: "banksPaginated",
	initialState: initialState,
	reducers: {
		clearError: (state: BanksListState) => {
			state.error = undefined
			state.loading = false
		},
		resetDefault: (state: BanksListState) => {
			state.loading = false
			state.loadingFetch = false
			state.error = undefined
			state.errorFetch = undefined
			state.list = undefined
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(getBanksPaginated.pending, (state: BanksListState) => {
				state.loading = true
				state.error = undefined
			})
			.addCase(
				getBanksPaginated.fulfilled,
				(state: BanksListState, action: PayloadAction<BanksListResponse>) => {
					state.loading = false
					state.error = undefined
					state.list = action?.payload
				}
			)
			.addCase(getBanksPaginated.rejected, (state: BanksListState, action) => {
				state.loading = false
				state.error = action?.payload.message
			})
			.addCase(fetchBanks.pending, (state: BanksListState) => {
				state.loadingFetch = true
				state.errorFetch = undefined
			})
			.addCase(
				fetchBanks.fulfilled,
				(state: BanksListState, action: PayloadAction<BanksListResponse>) => {
					state.loadingFetch = false
					state.errorFetch = undefined
					state.list = {
						nextUrl: action?.payload.nextUrl,
						page: {
							...action?.payload.page,
							content: [
								...state?.list?.page?.content,
								...action?.payload.page.content,
							],
						},
					}
				}
			)
			.addCase(fetchBanks.rejected, (state: BanksListState, action) => {
				state.loadingFetch = false
				state.errorFetch = action?.payload.message
			})
			.addCase(
				updateBank.fulfilled,
				(state: BanksListState, action: PayloadAction<BankState>) => {
					state.list = {
						...state.list,
						page: {
							...state.list?.page,
							content: state.list.page.content.map((bank: BankState) =>
								bank.bankId === action?.payload?.data?.bankId
									? action?.payload?.data
									: bank
							),
						},
					}
				}
			)
	},
})

export const { clearError, resetDefault } = bankPaginatedSlice.actions

export default bankPaginatedSlice.reducer
